import gridGalleryLarge from './widgetsStandarization/gridGalleryLarge.js';

import circleCards from './widgetsStandarization/circleCards.js';

import gridGallerySmall from './widgetsStandarization/gridGallerySmall.js';
import staticManagedSponsors from './widgetsStandarization/staticManagedSponsors.js';
import masonryCards from './widgetsStandarization/masonryCards.js';

import circleCardsSimple from './widgetsStandarization/circleCardsSimple.js';
import spinningNumbers from './widgetsStandarization/spinningNumbers.js';
import multipleSlideShows from './widgetsStandarization/multipleSlideShows.js';
import multipleSlideShowsVariant from './widgetsStandarization/multipleSlideShowsVariant.js';

import mainSlideshowConcept6 from './widgetsStandarization/mainSlideshowConcept6.js';

import scrollerSponsors from './widgetsStandarization/scrollerSponsors.js';

export default function () {
  const $body = $('body');

  const saffireConcepts = [
    'saffire-concept-1',
    'saffire-concept-2',
    'saffire-concept-3',
    'saffire-concept-4',
    'saffire-concept-5',
    'saffire-concept-6',
    'saffire-concept-7',
    'shared-concepts',
  ];

  // Función reutilizable que ejecuta una acción basada en la clase del body
  function executeSaffireFunction() {
    const activeClass = saffireConcepts.find((concept) => $body.hasClass(concept));

    switch (activeClass) {
      case 'saffire-concept-1':
        // Rendering Componentes
        enableContainer('1');
        addPopUp();
        gridGalleryLarge();
        // Rendering Componentes

        break;
      case 'saffire-concept-2':
        // Rendering Componentes
        addPopUp();
        enableContainer('2');
        circleCards();

        // Rendering Componentes

        break;
      case 'saffire-concept-3':
        // Rendering Componentes
        addPopUp();
        enableContainer('3');

        masonryCards();
        gridGallerySmall();
        staticManagedSponsors();
        // Rendering Componentes

        break;
      case 'saffire-concept-4':
        // Rendering Componentes
        addPopUp();
        enableContainer('4');
        multipleSlideShows('multipleSlideShowOne', multipleSlideShowOneOpts);
        multipleSlideShows('multipleSlideShowTwo', multipleSlideShowTwoOpts);

        multipleSlideShowsVariant('multipleSlideShowVariantOne', multipleSlideShowVariantOneOpts);
        multipleSlideShowsVariant('multipleSlideShowVariantTwo', multipleSlideShowVariantTwoOpts);

        circleCardsSimple();
        spinningNumbers();
        //  Rendering Componentes

        break;
      case 'saffire-concept-5':
        // Rendering Componentes
        addPopUp();
        enableContainer('5');

        // Rendering Componentes

        break;
      case 'saffire-concept-6':
        // Rendering Componentes
        addPopUp();
        enableContainer('6');
        mainSlideshowConcept6();
        // Rendering Componentes

        break;
      case 'saffire-concept-7':
        // Rendering Componentes
        addPopUp();
        enableContainer('7');
        // Rendering Componentes

        break;
      case 'shared-concepts':
        // Rendering Componentes
        addPopUp();
        enableContainer('8');
        scrollerSponsors();
        // Rendering Componentes

        break;
      default:
        console.log('No matching concept found');
    }
  }

  function enableContainer(value) {
    // $('.afterContent .concept-wrapper').remove;
    $(`.afterContent .concept-wrapper:not(.container-concept-${value})`).remove();
  }

  function addPopUp() {
    $('body .header').append(`
      <div class="pop-up-message">
      <span>Remember to test it on mobile</span>
      <span>(some features may required reload on mobile)</span>
      </div>
      `);
  }

  executeSaffireFunction();
}
